import { PagingMode } from './pagingMode'

export const DefaultMaxPageSize = {
  [PagingMode.Offset]: 1000,
  [PagingMode.Cursor]: 100
}
